import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  const handleDownloadApp = () => {
    // Add app download logic here
    console.log('Download app clicked');
    // You can redirect to app store or show download modal
  };

  const handleEnableNotifications = () => {
    // Add notification permission logic here
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          alert('Notifications enabled! You will receive updates about live darshans.');
        } else {
          alert('Notifications blocked. Please enable them in your browser settings.');
        }
      });
    } else {
      alert('This browser does not support notifications.');
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-orange-500 to-red-500">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t('neverMissSacredMoment')}
        </h2>
        <p className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto">
          {t('downloadAppForNotifications')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={handleDownloadApp}
            className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-orange-600 hover:to-red-600 transition-all transform hover:scale-105 shadow-xl border-2 border-white"
          >
            📲 {t('downloadApp')}
          </button>
          <button 
            onClick={handleEnableNotifications}
            className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-orange-600 hover:to-red-600 transition-all transform hover:scale-105 shadow-xl border-2 border-white"
          >
            🔔 {t('enableNotifications')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
